import React from 'react';
export function GuaranteeSection() {
  return <section className="w-full bg-beige py-12 md:py-20 px-4" data-id="element-139">
      <div className="max-w-[680px] mx-auto text-center" data-id="element-140">
        <div className="text-5xl mb-4" aria-hidden="true" data-id="element-141">
          🛡️
        </div>

        <h2 className="font-heading font-bold text-2xl md:text-3xl text-dark-gray mb-6" data-id="element-142">
          🛡️ Garantía de 7 Días Sin Preguntas
        </h2>

        <div className="font-body text-dark-gray text-base md:text-lg leading-relaxed space-y-4" data-id="element-143">
          <p data-id="element-144">
            Si abrís este ebook y sentís que no es lo que esperabas — por
            cualquier motivo — solo mandanos un email dentro de los 7 días y te
            devolvemos cada centavo.
          </p>
          <p data-id="element-145">Sin preguntas. Sin vueltas. Sin drama.</p>
          <p data-id="element-146">
            Estamos tan seguras de lo que hay adentro que ofrecemos esto sin
            dudarlo.
          </p>
        </div>
      </div>
    </section>;
}